module.exports = __webpack_public_path__ + "static/bg-wave-light-lightaus-blue-e220aaad26ab3cf5388347d438b2dcce.png";